import styled from "styled-components";

const StyleWrapper = styled.div`
    .missing_data {
      position: relative;
      display: inline-block;
      background: #c4314b;
      padding: 8px 18px;
      margin: 0 1rem 0 auto;
      float: right;
      font-family: tawuniya;
      font-size: 12px;
      font-weight: 800;
      line-height: 12px;
      letter-spacing: 0em;
      text-align: center;
      color: #fff;
      border-radius: 12px 6px 0px 0px;
      &::after {
        content: "";
        position: absolute;
        left: 42%;
        top: 100%;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #c4314b;
        clear: both;
      }
    }
   .whitebg{
    background:white !important;
    }
    .vehicle-item {
      display: flex;
      align-items: center;
     
      background: #f2f3f5;
      border-radius: 8px;
      width: 100%;
      margin: 0;
      &.missing {
        border: 1px solid #c4314b;
      }
    
      .vehicle-img {
        border-right: 1px solid rgba(26, 28, 31, 0.1);
        width: 12%;
        padding: 0;
      }
      .vehicle-details {
        width: 100%;
        .details {
          .title {
            font-size: 0.75rem;
            color: #676f7c;
          }
        }
        .plate {
          display: inline-flex;

          .plate-wrapper {
            width: 100%;
            max-width: 130px;
            position: relative;
            img {
              width: 100%;
            }
            .numbers {
              position: absolute;
              left: 10%;
              &.en {
                top: 22px;
              }
              &.ar {
                top: 1px;
              }
            }
            .chars {
              position: absolute;
              right: 25%;
              &.ar {
                top: 1px;
              }
              &.en {
                top: 22px;
              }
            }
          }
          & > * {
            float: right;
            position: relative;
            font-size: 8px;
            font-weight: bold;
            top: 5%;
            // &.chars{
              // right: 0;
              // left: 5%;
            // }
            &.numbers {
              right: 27%;
            }
          }
        }
      }
    }
    
    .vehicle-actions {
      border-left: 1px solid rgba(26, 28, 31, 0.1);
      width: 12%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      margin-left: 10px;
      padding: 0;
      button {
        border: none;
        outline: none;
        box-shadow: none;
        padding: 6px;
        margin: 0 5px;
        &.edit {
          background: #e3ffef;
        }
        &.remove {
          background: #fcf4f6;
        }
        &:hover {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
        }
      }
    }
    .p-calendar {
      z-index: 0 !important;
    }
    .p-calendar .p-button-icon-only {
      background: white;
      outline: none;
      box-shadow: none;
      border: none;
  }
  .p-inputtext,.p-inputnumber {
    font-size: 0.9rem;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
  }
  .p-inputgroup-addon{
    background: #F2F3F5;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
  }
  .field {
    input,
    .p-dropdown {
      box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
      border: none;
    }
  }

  .label{
    left:0 !important;
  }

  .fm-tawuniya.p-inputtext.p-filled, 
  .fm-tawuniya.p-inputtext.p-dropdown-label,
  .fm-tawuniya.p-inputtext.p-dropdown-label span
  {
    font-family: 'tawuniya' !important;
  }

  
`;

export default StyleWrapper;